import React from 'react';
import { IStaffMember } from '../../Staff/staff-hook';

export interface IEditStaffmember {
    data:IStaffMember;
    index:number;
    onClose:()=>void;
    company_id:number;
    onEdit:(data:IStaffMember,index:number)=>void
}

const EditStaffMember:React.FC<IEditStaffmember> = ({data}) => {
  return (
    <div>
      {`${data.first_name} ${data.last_name}`}
    </div>
  )
}

export default EditStaffMember
